var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScoringDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cddcfe",
    d: "M3.5 3.5L7 0H0z"
  })));
}
export default __webpack_public_path__ + "static/svg/scoring-down-arrow.svg";
export { SvgScoringDownArrow as ReactComponent };